<template>
    <div>
        <div style="z-index: 4; position: absolute; top: 0; bottom: 0; left: 0; right: 0;" @click.stop="tag_dropdown_open = false, system_dropdown_open = false, type_dropdown_open = false" v-if="tag_dropdown_open || system_dropdown_open || type_dropdown_open">
        </div>
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving_file">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file {{ saving_file_number }}, please wait
                </div>
            </div>
        </div>
        <div class="box" v-if="!loading">
            <div class="box-content">
                <div class="flex">
                    <div class="half-width pr-3">
                        <div class="form-group mb-0 full-height flex flex-col">
                            <label>Upload Image (Recommended size, no larger than 30mb)</label>
                            <form :action="`${$aws_upload_url}`" method="post"
                                  enctype="multipart/form-data" id="amazon_form">
                                <input type="hidden" name="policy" :value="aws_policy">
                                <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                <input type="hidden" name="x-amz-date" :value="aws_date">
                                <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                <input type="hidden" name="acl" value="private">
                                <input type="hidden" name="success_action_redirect" value="/downloads">
                            </form>
                            <vue-dropzone
                                    ref="fileUploadDropzone"
                                    id="dropzone"
                                    :options="dropzoneOptions"
                                    v-on:vdropzone-file-added="fileAddedToDropZone"
                                    v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                    :useCustomSlot="true"
                            >
                                <div>
                                    <div class="mb-3">
                                        DRAG AND DROP FILE
                                    </div>
                                    <div class="mb-3">
                                        OR
                                    </div>
                                    <div>
                                        <a class="btn-secondary-outline">
                                            Choose a file
                                        </a>
                                    </div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                    <div class="half-width pl-3">
                        <div class="form-group">
                            <label>Upload Type</label>
                            <div class="multi-select-input">
                                <div class="multi-select-input-placeholder" @click="type_dropdown_open = !type_dropdown_open">
                                    <template v-if="selected_content_upload_type">
                                        {{ selected_content_upload_type.name }}
                                    </template>
                                    <template v-else>
                                        Select Type ...
                                    </template>
                                    <div class="dropdown-icon">
                                        <i class="fal fa-chevron-down"></i>
                                    </div>
                                </div>
                                <div class="multi-select-input-inner" v-show="type_dropdown_open" @click="type_dropdown_open = false">
                                    <div class="multi-select-input-group">
                                        <div class="radios">
                                            <div class="radio level-1" v-for="content_upload_type in content_upload_types">
                                                <label>
                                                    <input type="radio" name="content_upload_type" :value="content_upload_type.id" v-model="content_upload_type_id">
                                                    <span class="radio-label">{{ content_upload_type.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Systems</label>
                            <div class="multi-select-input">
                                <div class="multi-select-input-placeholder" @click="system_dropdown_open = !system_dropdown_open">
                                    <template v-if="selected_system_types.length > 0">
                                        <span v-for="type in selected_system_types">{{ type.label }}, </span>
                                    </template>
                                    <template v-else>
                                        Select Systems ...
                                    </template>
                                    <div class="dropdown-icon">
                                        <i class="fal fa-chevron-down"></i>
                                    </div>
                                </div>
                                <div class="multi-select-input-inner" v-show="system_dropdown_open">
                                    <div class="multi-select-input-group">
                                        <div class="checkboxes">
                                            <div class="checkbox level-1" v-for="system_type in system_types">
                                                <label>
                                                    <input type="checkbox" name="epwin_system_types" :value="system_type.id" v-model="epwin_system_type_ids">
                                                    <span class="checkbox-label">{{ system_type.label }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <label>Tags</label>
                            <div class="multi-select-input">
                                <div class="multi-select-input-placeholder" @click="tag_dropdown_open = !tag_dropdown_open">
                                    <template v-if="selected_tags.length > 0">
                                        <span v-for="tag in selected_tags">{{ tag.name }}, </span>
                                    </template>
                                    <template v-else>
                                        Select Tags ...
                                    </template>
                                    <div class="dropdown-icon">
                                        <i class="fal fa-chevron-down"></i>
                                    </div>
                                </div>
                                <div class="multi-select-input-inner" v-show="tag_dropdown_open">
                                    <div class="multi-select-input-group">
                                        <div class="checkboxes">
                                            <div class="checkbox level-1" v-for="tag in tags">
                                                <label>
                                                    <input type="checkbox" name="tags" :value="tag.id" v-model="content_upload_tags">
                                                    <span class="checkbox-label">{{ tag.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="align-right mt-3">
                    <a class="btn-primary" @click.prevent="save()">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';

export default {
    props: [
       'aws_policy',
       'aws_credential',
       'aws_date',
       'aws_signature',
    ],
    components: {
        'vue-dropzone': vue2Dropzone,
    },
    data() {
        return {
            system_types: [],
            content_upload_types: [],
            tags: [],
            content_uploads: [],
            loading: true,
            saving_file: false,
            uploaded_file: null,
            dropzoneOptions: {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
            },
            tag_dropdown_open: false,
            system_dropdown_open: false,
            type_dropdown_open: false,
            content_upload_type_id: null,
            epwin_system_type_ids: [],
            content_upload_tags: [],
            saving_file_number: 0,
        };
    },
    computed: {
      selected_content_upload_type() {
        return this.content_upload_types.filter((type) => type.id === this.content_upload_type_id)[0];
      },
      selected_system_types() {
        return this.system_types.filter((type) => this.epwin_system_type_ids.includes(type.id));
      },
      selected_tags() {
        return this.tags.filter((tag) => this.content_upload_tags.includes(tag.id));
      },
    },
    async mounted() {
        await this.loadTags();
        await this.loadSystemTypes();
        await this.loadContentUploadTypes();
        this.loading = false;
    },
    methods: {
        fileAddedToDropZone(uploadedFile) {
            const extension = uploadedFile.name.replace(/^.*\./, '');
            const original_file_name = uploadedFile.name.replace('.'+extension, '');

            let new_upload = {};

            new_upload.name = original_file_name;
            const filename = 'content_uploads/'+ original_file_name + '_' + Date.now();
            new_upload.filename = filename + '.' + extension;

            if(extension.toLowerCase() === 'svg') {
                new_upload.thumbnail_url = new_upload.filename;
            } else {
                new_upload.thumbnail_url = 'thumbnails/' + filename + '.png';
            }

            new_upload.filetype = uploadedFile.type;
            new_upload.uploaded_file = uploadedFile;

            this.content_uploads.push(new_upload);
        },
        fileRemovedFromDropZone(file) {
          const extension = file.name.replace(/^.*\./, '');
          const original_file_name = file.name.replace('.' + extension, '');
          this.content_uploads = this.content_uploads.filter(attachment => attachment.original_file_name !== original_file_name);
        },
        async loadTags() {
            await axios.get('/downloads/getTags').then((response) => {
                this.tags = response.data;
            });
        },
        async loadSystemTypes() {
          await axios.get('/downloads/getSystemTypes').then((response) => {
                this.system_types = response.data;
            });
        },
        async loadContentUploadTypes() {
          await axios.get('/downloads/getContentUploadTypes').then((response) => {
            this.content_upload_types = response.data;
          });
        },
        async save() {
            this.saving_file = true;
            this.saving_file_number = 1;

            await this.content_uploads.forEach(async (upload, index) => {
              await axios.post('/downloads/create',{
                content_upload: {
                    'name': upload.name,
                    'filename': upload.filename,
                    'thumbnail_url': upload.thumbnail_url,
                    'epwin_system_type_ids': this.epwin_system_type_ids,
                    'content_upload_type_id': this.content_upload_type_id,
                    'sort_order': 0,
                    'tags': this.content_upload_tags,
                },
              }).then(async () => {
                let form_data = new FormData(document.querySelector('#amazon_form'));
                form_data.append('Content-Type', upload.filetype);
                form_data.append('key', upload.filename);
                form_data.append('file', upload.uploaded_file);

                await axios({
                  method: 'post',
                  url: this.$aws_upload_url,
                  data: form_data,
                  headers: {'Content-Type': 'multipart/form-data' }
                }).then(async () => {
                  this.saving_file_number = this.saving_file_number + 1;

                  if(this.saving_file_number === this.content_uploads.length + 1) {
                    this.saving_file = false;
                    this.saving_file_number = 0;
                    this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
                    this.content_upload_type_id = null;
                    this.epwin_system_type_ids = [];
                    this.content_upload_tags = [];
                    this.content_uploads = [];

                    Swal.fire({
                      title: 'Finished',
                      icon: 'success',
                    });
                  }
                });

              });
            });

        },
    },
    watch: {
      tag_dropdown_open() {
        if (this.tag_dropdown_open) {
          this.system_dropdown_open = false;
          this.type_dropdown_open = false;
        }
      },
      system_dropdown_open() {
        if (this.system_dropdown_open) {
          this.tag_dropdown_open = false;
          this.type_dropdown_open = false;
        }
      },
      type_dropdown_open() {
        if (this.type_dropdown_open) {
          this.tag_dropdown_open = false;
          this.system_dropdown_open = false;
        }
      },
    },
};
</script>
